import classNames from "classnames";
import i18n from "i18next";
import React, { useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { assetsStaticURL, DOMAIN } from "../../../constants";
import * as actions from "../../../store/actions";
import Link from "../../common/Link";
import useOutsideClick from "../../hook/useOutsideClick";
import IconAngelSVG from "../../svg/icon-angel";
import IconCloseSVG from "../../svg/icon-close";
import IconLogOutSVG from "../../svg/icon-logout";
import IconShevronDownSVG from "../../svg/icon-shevron-down";
import IconUserSVG from "../../svg/icon-user";
import MenuSVG from "../../svg/menu";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import styles from "./Navigation.module.scss";

const Navigation = (props) => {
  const { t } = useTranslation();
  const ref = useRef();
  const dispatch = useDispatch();
  const isShowSidebar = useSelector((state) => state.app.isShowSidebar);
  const { isMobile } = props;

  const urlPathHasAngel = props.location.pathname.includes("angel");

  const [cookies, setCookie, removeCookie] = useCookies(["TOKEN"]);
  const userInfo = useSelector((state) => state.auth.info);

  const { isAffiliate, name } = userInfo;
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);

  const handleLogout = () => {
    console.log("logout");
    dispatch(actions.removeUserInfo());

    removeCookie("TOKEN", {
      path: "/",
      domain: "." + window.location.hostname.split(".").reverse()
          .slice(0, 2).reverse()
          .join("."),
    });

    props.setAuthenticated(false);
    if (DOMAIN) {
      if (isAffiliate) {
        window.location = DOMAIN + "/affiliates";
      } else {
        window.location = DOMAIN;
      }
    } else props.history.push("/my");
  };

  useOutsideClick(ref, () => {
    setMobileDropdownOpen(false);
  });

  return (
    <nav className={classNames(styles.navigation)}>
      {/*{isMobile && <div className={styles.backdrop} onClick={() => toggle(!isOpen)}>*/}

      {/*</div>}*/}
      {isMobile ? (
        <div className={styles.header}>
          <Link className={styles.logo} href={`${i18n.language === "en" ? "/" : "/" + i18n.language}`}>
            {urlPathHasAngel && (
              <>
                <IconAngelSVG className={styles.angelLogo} />
                <span className={styles.logoHr}></span>
              </>
            )}
            <img
              className={styles.userLogo}
              //src={`${assetsStaticURL}logo/radical-storage-network-${i18n.language === "en" ? "default" : i18n.language}.png`}
              src={`${assetsStaticURL}logo/radical-storage-network-default.svg`}
              alt="tml-description-homepage"
            />
          </Link>

          {!props.hideSideNav && (
            <span className={styles.toggler} onClick={() => dispatch(actions.toggleSidebar())}>
              {!isShowSidebar ? <MenuSVG /> : <IconCloseSVG />}
            </span>
          )}
        </div>
      ) : (
        <Link className={styles.logo} href={`${i18n.language === "en" ? "/" : "/" + i18n.language}`}>
          {urlPathHasAngel && (
            <>
              <IconAngelSVG className={styles.angelLogo} />
              <span className={styles.logoHr}></span>
            </>
          )}
          <img
            className={styles.userLogo}
            //src={`${assetsStaticURL}logo/radical-storage-network-${i18n.language === "en" ? "default" : i18n.language}.png`}
            src={`${assetsStaticURL}logo/radical-storage-network-default.svg`}
            alt="tml-description-homepage"
          />
        </Link>
      )}

      <div className={styles.menu}>
        {!isMobile && (
          <ul className={styles.menuList}>
            {!props.hideSideNav && (
              <>
                <li className={styles.item}>
                  <span className={styles.link}>
                    <IconUserSVG className={styles.icon} /> {t("Hi")} {name && name.split(" ")[0]}
                  </span>
                </li>
                <li className={styles.item}>
                  <span className={styles.link} onClick={handleLogout}>
                    <IconLogOutSVG className={styles.icon} /> {t("Log out")}
                  </span>
                </li>
              </>
            )}

            <li className={classNames([styles.item, styles.link])}>
              <LanguageSwitcher className={"standart"} />
            </li>
          </ul>
        )}
        {isMobile && (
          <div className={styles.mobileDropdownWrap} ref={ref}>
            <div className={styles.dropdownTogler} onClick={() => setMobileDropdownOpen((prevState) => !prevState)}>
              {!props.hideSideNav && (
                <span>
                  <IconUserSVG className={styles.icon} />
                </span>
              )}
              <IconShevronDownSVG />
            </div>
            {mobileDropdownOpen && (
              <ul className={styles.mobileDropdown}>
                <li className={styles.mobileDropdownItem}>
                  <LanguageSwitcher isMobile={true} className={"standart"} onClose={() => setMobileDropdownOpen(false)} />
                </li>
                {!props.hideSideNav && (
                  <li className={styles.standartDropdownItem} onClick={handleLogout}>
                    {t("Log out")}
                  </li>
                )}
              </ul>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default withRouter(Navigation);
